export class TeamUser
{
	teamId: number;
  userId:  number;
  userRole:  number;
  permission:  number;
}
